import _Dropdown from './DropDown'
import { withInstall } from '../utils'
import './index.scss'

export const Dropdown = withInstall(_Dropdown)
export default Dropdown
